const apiStateCheckReducer = (state = {}, action) => {
  const regex = /(_(SUCCESS|INITIATE|FAILED|CLEAR))$/g;
  const matched = action.type.match(regex);
  let apiStatus = '';
  let apiName = '';

  if (matched && matched.length && action.type.split(matched[0])[0]) {
    [apiName] = action.type.split(matched[0]);
    apiStatus = matched[0].slice(1);
  }

  switch (apiStatus) {
    case 'INITIATE':
      return {
        ...state,
        [apiName]: {
          isIdle: false,
          isFetching: true,
        },
      };
    case 'SUCCESS':
      return {
        ...state,
        [apiName]: {
          isIdle: false,
          isFetching: false,
          success: true,
        },
      };
    case 'FAILED':
      return {
        ...state,
        [apiName]: {
          isIdle: false,
          isFetching: false,
          success: false,
        },
      };
    case 'CLEAR':
      return {
        ...state,
        [apiName]: {
          isIdle: true,
          isFetching: false,
        },
      };
    default:
      return state;
  }
};

export default apiStateCheckReducer;
